import { Howl, Howler } from 'howler';

const audio = {
  muted: false,
  sounds: [
    {
      id: 'background',
      ref: null,
      src: '/static/audio/background.mp3',
    }, {
      id: 'buyit',
      ref: null,
      src: '/static/audio/buyit.mp3',
    },
  ],

  load() {
    audio.sounds.forEach((sound) => {
      sound.ref = new Howl({ src: [sound.src] });
    });
    audio.mute();
  },

  get(id) {
    let found;
    audio.sounds.forEach((sound) => {
      if (sound.id === id) found = sound;
    });
    return found;
  },

  play(id) {
    audio.sounds.forEach((sound) => {
      if (sound.id === id) sound.ref.play();
    });
  },

  pause(id) {
    audio.sounds.forEach((sound) => {
      if (sound.id === id) sound.ref.pause();
    });
  },

  mute() {
    Howler.mute(true);
    audio.muted = true;
  },

  unmute() {
    Howler.mute(false);
    audio.muted = false;
  },
};

export default audio;
